import { useState, useCallback } from 'react';
import { Routes, Route } from 'react-router-dom';
import { MainLayout, Sidebar, MobileHeader, MobileMenu } from '@/components/layout';
import {
  LandingPage,
  FeaturesPage,
  PricingPage,
  EnterprisePage,
  AboutPage,
  VisionPage,
  DemoPage,
  TermsPage,
  PrivacyPage,
  InvestorsPage,
  PitchDeckPage,
  OnePagerPage,
} from '@/pages';

export function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = useCallback(() => {
    setIsMenuOpen((prev) => !prev);
  }, []);

  const closeMenu = useCallback(() => {
    setIsMenuOpen(false);
  }, []);

  return (
    <MainLayout>
      <Sidebar />
      <MobileHeader isMenuOpen={isMenuOpen} onToggleMenu={toggleMenu} />
      <MobileMenu isOpen={isMenuOpen} onClose={closeMenu} />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/features" element={<FeaturesPage />} />
        <Route path="/demo" element={<DemoPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/enterprise" element={<EnterprisePage />} />
        <Route path="/vision" element={<VisionPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/investors" element={<InvestorsPage />} />
        {/* Direct-access investor material — deliberately absent from Sidebar and MobileMenu */}
        <Route path="/pitch" element={<PitchDeckPage />} />
        <Route path="/one-pager" element={<OnePagerPage />} />
      </Routes>
    </MainLayout>
  );
}
